import { useQuery } from '@tanstack/react-query';
import { requestTyped } from '@xdocs/ws-protocol';
import type { AdminBillingOverviewResult, ErrorAlert } from '@xdocs/schemas';
import { useWs } from '../../../ws/WsProvider.js';

export const ADMIN_BILLING_OVERVIEW_QUERY_KEY = ['admin-billing-overview'] as const;

export interface UseBillingOverviewResult {
  data: AdminBillingOverviewResult | undefined;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
}

/**
 * `admin.billing.overview` (F70) — aggregated cached read-model (E1), NOT a
 * warehouse. Snapshot-shaped (no payload), so this is a plain `useQuery`
 * rather than a `<DataTable>` bridge.
 */
export function useBillingOverview(): UseBillingOverviewResult {
  const { wsClient, connectionState } = useWs();
  const enabled = connectionState === 'connected';

  const result = useQuery<AdminBillingOverviewResult, ErrorAlert>({
    queryKey: ADMIN_BILLING_OVERVIEW_QUERY_KEY,
    queryFn: () => requestTyped(wsClient, 'admin.billing.overview', undefined),
    enabled,
  });

  return {
    data: result.data,
    isLoading: result.isLoading,
    isError: result.isError,
    onRetry: () => void result.refetch(),
  };
}
